const routes = [
  {
    path: '/empresa',
    name: 'Empresas',
    component: () => import('@/views/forms/Empresa.vue')
  },
  {
    path: '/usuario',
    name: 'Usuarios',
    component: () => import('@/views/forms/Usuario.vue')
  },
  {
    path: '/generarfechascitas',
    name: 'Generar Fechas Citas',
    component: () => import('@/views/utils/GenerarFechasCitas.vue')
  },
  {
    path: '/anatomia',
    name: 'Anatomía',
    component: () => import('@/views/forms/Anatomia.vue')
  },
  {
    path: '/antecedente',
    name: 'Antecedente',
    component: () => import('@/views/forms/Antecedente.vue')
  },
  {
    path: '/atencion',
    name: 'Atenciones',
    component: () => import('@/views/forms/Atencion.vue')
  },
  {
    path: '/biometria',
    name: 'Biometría',
    component: () => import('@/views/forms/Biometria.vue')
  },
  {
    path: '/cita',
    name: 'Citas',
    component: () => import('@/views/forms/Cita.vue')
  },
  {
    path: '/clasdiag',
    name: 'Clasificación de Diagnósticos',
    component: () => import('@/views/forms/ClasDiag.vue')
  },
  {
    path: '/claselem',
    name: 'Clasificación de Elementos',
    component: () => import('@/views/forms/ClasElem.vue')
  },
  {
    path: '/consejo',
    name: 'Consejos',
    component: () => import('@/views/forms/Consejo.vue')
  },
  {
    path: '/diagnostico',
    name: 'Diagnóstico',
    component: () => import('@/views/forms/Diagnostico.vue')
  },
  {
    path: '/elemento',
    name: 'Elemento',
    component: () => import('@/views/forms/Elemento.vue')
  },
  {
    path: '/empresaimg',
    name: 'Empresa Imagen',
    component: () => import('@/views/forms/EmpresaImg.vue')
  },
  {
    path: '/especialidad',
    name: 'Especialidad',
    component: () => import('@/views/forms/Especialidad.vue')
  },
  {
    path: '/estadocivil',
    name: 'Estado Civil',
    component: () => import('@/views/forms/EstadoCivil.vue')
  },
  {
    path: '/examaten',
    name: 'Examen Atención',
    component: () => import('@/views/forms/ExamAten.vue')
  },
  {
    path: '/examenfisico',
    name: 'Examen Físico',
    component: () => import('@/views/forms/ExamenFisico.vue')
  },
  {
    path: '/fechacita',
    name: 'Fecha Cita',
    component: () => import('@/views/forms/FechaCita.vue')
  },
  {
    path: '/formapago',
    name: 'Forma de Pago',
    component: () => import('@/views/forms/FormaPago.vue')
  },
  {
    path: '/horario',
    name: 'Horarios',
    component: () => import('@/views/forms/Horario.vue')
  },
  {
    path: '/interconsulta',
    name: 'Interconsulta',
    component: () => import('@/views/forms/Interconsulta.vue')
  },
  {
    path: '/localidad',
    name: 'Localidades',
    component: () => import('@/views/forms/Localidad.vue')
  },
  {
    path: '/medico',
    name: 'Médico',
    component: () => import('@/views/forms/Medico.vue')
  },
  {
    path: '/mediocom',
    name: 'Medios de Comunicación',
    component: () => import('@/views/forms/MedioCom.vue')
  },
  {
    path: '/mediocomimg',
    name: 'Medio Com Imagen',
    component: () => import('@/views/forms/MedioComImg.vue')
  },
  {
    path: '/medioemp',
    name: 'Empresa Medios de Comunicación',
    component: () => import('@/views/forms/MedioEmp.vue')
  },
  {
    path: '/mediopers',
    name: 'Persona Medios de Comunicación',
    component: () => import('@/views/forms/MedioPers.vue')
  },
  {
    path: '/modulo',
    name: 'Módulos',
    component: () => import('@/views/forms/Modulo.vue')
  },
  {
    path: '/moduplan',
    name: 'Módulos por Plan',
    component: () => import('@/views/forms/ModuPlan.vue')
  },
  {
    path: '/moduusua',
    name: 'Módulos por Usuarios',
    component: () => import('@/views/forms/ModuUsua.vue')
  },
  {
    path: '/parametro',
    name: 'Parámetros',
    component: () => import('@/views/forms/Parametro.vue')
  },
  {
    path: '/paremp',
    name: 'Parámetros por Empresa',
    component: () => import('@/views/forms/ParEmp.vue')
  },
  {
    path: '/pedido',
    name: 'Pedidos',
    component: () => import('@/views/forms/Pedido.vue')
  },
  {
    path: '/pedidodet',
    name: 'Pedido Detalles',
    component: () => import('@/views/forms/PedidoDet.vue')
  },
  {
    path: '/perfil',
    name: 'Perfiles de Usuario',
    component: () => import('@/views/forms/Perfil.vue')
  },
  {
    path: '/persona',
    name: 'Personas',
    component: () => import('@/views/forms/Persona.vue')
  },
  {
    path: '/plan',
    name: 'Planes',
    component: () => import('@/views/forms/Plan.vue')
  },
  {
    path: '/plandiag',
    name: 'Plan Diagnóstico',
    component: () => import('@/views/forms/PlanDiag.vue')
  },
  {
    path: '/plantera',
    name: 'Plan Terapéutico',
    component: () => import('@/views/forms/PlanTera.vue')
  },
  {
    path: '/receta',
    name: 'Receta',
    component: () => import('@/views/forms/Receta.vue')
  },
  {
    path: '/recetadet',
    name: 'Receta Detalles',
    component: () => import('@/views/forms/RecetaDet.vue')
  },
  {
    path: '/rol',
    name: 'Roles de Usuarios',
    component: () => import('@/views/forms/Rol.vue')
  },
  {
    path: '/rolmodu',
    name: 'Roles por Módulo',
    component: () => import('@/views/forms/RolModu.vue')
  },
  {
    path: '/sesion',
    name: 'Sesiones',
    component: () => import('@/views/forms/Sesion.vue')
  },
  {
    path: '/sesionerr',
    name: 'Sesiones Error',
    component: () => import('@/views/forms/SesionErr.vue')
  },
  {
    path: '/suscpago',
    name: 'Pagos por Suscripción',
    component: () => import('@/views/forms/SuscPago.vue')
  },
  {
    path: '/suscripcion',
    name: 'Suscripción',
    component: () => import('@/views/forms/Suscripcion.vue')
  },
  {
    path: '/tablmodu',
    name: 'Tablas por Módulo',
    component: () => import('@/views/forms/TablModu.vue')
  },
  {
    path: '/tipoelem',
    name: 'Tipos de Elementos',
    component: () => import('@/views/forms/TipoElem.vue')
  },
  {
    path: '/tipoexamen',
    name: 'Tipo de Examen',
    component: () => import('@/views/forms/TipoExamen.vue')
  },
  {
    path: '/tipoiden',
    name: 'Tipos de Identificación',
    component: () => import('@/views/forms/TipoIden.vue')
  },
  {
    path: '/tratamiento',
    name: 'Tratamiento',
    component: () => import('@/views/forms/Tratamiento.vue')
  },
  {
    path: '/usuario',
    name: 'Usuarios',
    component: () => import('@/views/forms/Usuario.vue')
  }
];

export { routes };
